import {
  FieldOkConfig,
  FieldOkListViewComponent,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent
} from "@softline/dynamic";
import { PreisebeneListView } from "./list-view/preisebene.list-view";

export const preisebeneFieldOk: FieldOkConfig = {
  name: 'preisebene',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: FieldOkListViewComponent,
    title: 'Auswahl',
    config: {
      component: PreisebeneListView,
      sort: {
        properties: [
          {property: 'preisebene', title: 'Preisebene'},
        ]
      }
    }
  }
  ]
};
export const preisebeneMultiselectFieldOk: FieldOkConfig = {
  name: 'preisebene',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: FieldOkMultiselectListViewComponent,
    title: 'Auswahl',
    config: {
      component: PreisebeneListView,
      sort: {
        properties: [
          {property: 'preisebene', title: 'Preisebene'},
        ]
      }
    }
  }
  ]
};

export const preisebeneQueryFieldOk: FieldOkConfig = {
  name: 'preisebene',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: QueryFieldOkListViewComponent,
    title: 'Auswahl',
    config: {
      component: PreisebeneListView,
      sort: {
        properties: [
          {property: 'preisebene', title: 'Preisebene'},
        ]
      }
    }
  }
  ]
};
